module.exports = __webpack_public_path__ + "media/images/client-34-2f23cde7c2b2aff74353c36cbe3c79ee.svg";